import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import SVGInline from "react-svg-inline"

import { ButtonSimple } from '../../Elements/Buttons';

// svgs
import bounceSVG from './img/bounceSvgString';
import lightningSvg from '../../inlineSVGs/lightningSVG';
import notePurpleMugicsSVG from '../../inlineSVGs/notePurpleMugicsSVG';
import closeCrossSVG from '../../inlineSVGs/closeCrossSVG';

// styles
import '../stylesModal.css';
import './styles.css';

// your event just got boosted to the top
// Now it your turn to be first
const BounceMessage = ({ isModalOpen, closeModal }) => {
    return (
        <Modal
            isOpen={isModalOpen}
            contentLabel="Modal"
            className="modal-wrapper bounce-message-modal"
            style={{overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0)'
                }}}
        >
            <div className="close-button-container">

                <div onClick={closeModal} >
                    <SVGInline className="close-button" svg={closeCrossSVG} component="i"/>
                </div>
            </div>
            <SVGInline svg={notePurpleMugicsSVG} width="100px" component="i" className="mugics-icon" />

            <div className="content">
                <h3>המודעה שלכם הוקפצה לפסגה</h3>
                <SVGInline svg={lightningSvg} width="25" fill="#6dc6b0"/>
                <p>עכשיו תורכם להיות ראשונים</p>
                <SVGInline svg={bounceSVG} className="svg-wrapper"/>
                <ButtonSimple onPress={closeModal} label="אישור" customClass="bounce-message-button"/>
            </div>
        </Modal>
    )
};

BounceMessage.propTypes = {
    header: PropTypes.string,
    content: PropTypes.string,
    closeModal: PropTypes.func,
    isModalOpen: PropTypes.bool
};

export default BounceMessage;



// WEBPACK FOOTER //
// ./src/Components/Modals/BounceMessage/BounceMessage.js